<template>
  <div class="c-author-spotlight u-author h-card">
    <h2 class="m-0 mb-6 text-4 gamma:text-5">About the author</h2>

    <cloudinary-image
      class="float-left mr-6 mb-6 rounded-full u-photo"
      :source-url="gravatarUrl"
      :source-width="gravatarSize"
      :source-height="gravatarSize"
      :widths="avatarWidths"
      :sizes="`${avatarSize}px`"
      :width="avatarSize"
      :height="avatarSize"
      :lazyload="true"
      :fallback="true"
      alt="A profile photo of Saul Hardman"
    />

    <p class="c-author-spotlight__paragraph m-0 leading-normal">
      Hiya, I'm
      <viewsource-link
        href="https://saulhardman.com"
        rel="me"
        class="p-name u-url"
        >Saul Hardman</viewsource-link
      >, a <span class="p-job-title">front-end web developer</span> based in
      <span class="p-locality">Copenhagen</span>,
      <span class="p-country-name">Denmark</span>. I'm currently available for
      work, so if you need help building websites, web applications, and
      everything in between
      <viewsource-link href="mailto:saul@saulhardman.com"
        >get in touch</viewsource-link
      >!
    </p>

    <p class="c-author-spotlight__paragraph leading-normal">
      To stay up to date, follow me on
      <viewsource-link
        href="https://twitter.com/saulhardman"
        rel="me"
        title="Follow Saul on Twitter"
        >Twitter</viewsource-link
      >
      and
      <viewsource-link
        href="https://github.com/saulhardman"
        rel="me"
        title="Explore Saul's Open Source Projects on GitHub"
        >GitHub</viewsource-link
      >
      and be sure to subscribe to the
      <viewsource-link
        rel="alternate"
        type="application/rss+xml"
        href="/feed.xml"
        >RSS feed</viewsource-link
      >.
    </p>
  </div>
</template>

<script>
import CloudinaryImage from '@saulhardman/vue-cloudinary-image';

import ViewsourceLink from '~/components/ViewsourceLink.vue';

const gravatarSize = 512;
const gravatarPath =
  'https://www.gravatar.com/avatar/299f53687e3f125297da19bddc0ac222';
const gravatarQuery = `s=${gravatarSize}`;
const gravatarUrl = `${gravatarPath}?${gravatarQuery}`;

const avatarWidths = [96, 192, 288];
const avatarSize = 96;

export default {
  components: {
    CloudinaryImage,
    ViewsourceLink,
  },

  data() {
    return {
      avatarWidths,
      avatarSize,
      gravatarSize,
      gravatarUrl,
    };
  },
};
</script>

<style lang="postcss">
.c-author-spotlight__paragraph {
  @nest & + .c-author-spotlight__paragraph {
    margin-top: var(--spacing-4);

    @media (--beta) {
      margin-top: var(--spacing-6);
    }
  }
}
</style>
